import { useEffect } from 'react';
import ReactDOM from 'react-dom';

const Spinner = () => {
	const spinnerElement: any = document.getElementById('spinner');

	useEffect(() => {
		const bodyElement: HTMLBodyElement = document.getElementsByTagName('body')[0];
		bodyElement.classList.add('loader-open');

		return () => {
			bodyElement.classList.remove('loader-open');
		};
	}, []);

	return ReactDOM.createPortal(
		<div className="spinner_overlay">
			<div id="bars2">
				<span className="sr-only" role="alert" aria-live="assertive">
					Loading content
				</span>
				<img
					src="/en/account/images/web_loadingspinner.apng.png"
					className="loading-img"
					alt="loader"
				/>
			</div>
		</div>,
		spinnerElement
	);
};

export default Spinner;
